import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type LocationMethod = 'gps' | 'manual' | 'saved'

export interface LocationState {
  latitude: number | null
  longitude: number | null
  address: string | null
  method: LocationMethod | null
  lastGpsAddress: string | null
  lastGpsLat: number | null
  lastGpsLng: number | null
  setLocation: (lat: number, lng: number, address: string, method: LocationMethod) => void
  setLastGpsLocation: (lat: number, lng: number, address: string) => void
  clearLocation: () => void
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      latitude: null,
      longitude: null,
      address: null,
      method: null,
      lastGpsAddress: null,
      lastGpsLat: null,
      lastGpsLng: null,
      setLocation: (lat, lng, address, method) => set({ latitude: lat, longitude: lng, address, method }),
      setLastGpsLocation: (lat, lng, address) => set({ lastGpsLat: lat, lastGpsLng: lng, lastGpsAddress: address }),
      clearLocation: () => set({ latitude: null, longitude: null, address: null, method: null }),
    }),
    {
      name: 'customer-location',
    },
  ),
)
